import React, { FC } from 'react';
import classNames from 'classnames';
import { addSeparatorBetweenElements } from '../../../utils/jsxUtils';
import styles from './commentary_subtitle.module.scss';

type Props = {
  items: Array<{ label: string; highlight?: boolean }>;
};

export const CommentarySubtitle: FC<Props> = ({ items }) => {
  return (
    <div className={styles.container}>
      {addSeparatorBetweenElements(
        items.map((item) => (
          <span
            className={classNames({ [styles.highlight]: item.highlight })}
            dangerouslySetInnerHTML={{ __html: item.label }}
          />
        )),
        ' . ',
      )}
    </div>
  );
};
